import { create } from 'zustand'

import {
  CareBookingInitData,
  ServiceBookingInitData,
} from 'interfaces/types/QuickBooking'

import { QuickBookingStoreType, QuickBookingType } from './types'

export const useQuickBookingStore = create<QuickBookingStoreType>((set) => ({
  openQuickBookingDrawer: false,
  setOpenQuickBookingDrawer(isOpen: boolean) {
    set({ openQuickBookingDrawer: isOpen })
  },
  careType: QuickBookingType.DOCTOR,
  setCareType(careType: QuickBookingType) {
    set({ careType })
  },
  setData(data: CareBookingInitData | ServiceBookingInitData) {
    set({ data })
  },
}))
